<section *ngIf="event">
  <div class="container-fluid pb-4">
    <ng-container>
      <div
        class="mb-5"
        [ngClass]="{
          row: !mobileDevice
        }"
      >
        <div class="col-12 col-md-7 col-lg-7 px-0">
          <ngb-carousel
            [dir]="translate.currentLang == 'ar' ? 'rtl' : 'ltr'"
            *ngIf="event?.gallery && event?.gallery.length > 1"
            [interval]="3000"
            [wrap]="true"
            [pauseOnHover]="false"
          >
            <ng-template *ngFor="let image of event?.gallery" ngbSlide>
              <div class="picsum-img-wrapper">
                <img
                  class="event-image w-100"
                  [src]="image.url"
                  alt="Random first slide"
                />
              </div>
            </ng-template>
          </ngb-carousel>
          <div
            *ngIf="event?.gallery && event?.gallery.length == 1"
            class="ratio-wrapper"
          >
            <img
              [src]="event.gallery[0]?.url"
              class="ratio-wrapper__el event-image"
              alt=""
            />
          </div>
          <div class="card-content upper-radius">
            <div class="mb-5">
              <div class="d-flex justify-content-between align-items-center">
                <h2 class="event-title">
                  {{ helpers.getElementTranslatedName(event) }}
                </h2>
              </div>
              <div class="d-flex event-description">
                <p>{{ "Event Description" | translate }}</p>
              </div>

              <div
                [innerHTML]="
                  translate.currentLang === 'ar'
                    ? (event?.descriptionAr | safeHTML)
                    : event?.descriptionEn
                    ? (event?.descriptionEn | safeHTML)
                    : (event?.descriptionAr | safeHTML)
                "
              ></div>
            </div>
          </div>
          <div
            *ngIf="event.policies?.length > 0 && !mobileDevice"
            class="card-content mt-4 content-radius"
            style="cursor: pointer"
            (click)="openPloliciesMobile = !openPloliciesMobile"
          >
            <div class="d-flex justify-content-between align-items-center my-4">
              <h2 class="event-title">
                {{ "Terms and Conditions" | translate }}
              </h2>
              <i *ngIf="!openPloliciesMobile" class="fa fa-chevron-down"></i>
              <i *ngIf="openPloliciesMobile" class="fa fa-chevron-up"></i>
            </div>
            <div *ngIf="openPloliciesMobile">
              <div
                *ngFor="let policy of event?.policies"
                [innerHTML]="policy?.nameAr | safeHTML"
              ></div>
            </div>
          </div>
        </div>

        <div class="col-1"></div>
        <div
          class="details-card"
          [ngClass]="{
            col: !mobileDevice
          }"
        >
          <div class="bk-white">
            <div>
              <div>
                <p class="organiser">{{ "TheEventStartsOn" | translate }} :</p>
                <p class="organiser-name">
                  {{
                    event.schedules[0]?.startAt * 1000
                      | localizedDate : "EEEE, MMM d, y" : translate.currentLang
                  }}
                </p>
              </div>
              <div *ngIf="getLeastPrice() !== -1">
                <p class="organiser">{{ "PricesStartsWith" | translate }} :</p>
                <p class="organiser-name price">
                  <span *ngIf="getLeastPrice() === 0">
                    {{ "free" | translate }}
                  </span>
                  <span *ngIf="getLeastPrice() !== 0">
                    <span
                      [innerHTML]="
                        getLeastPrice()
                          | toVat
                          | customCurrency : 'SAR' : 'symbol' : '#E5263D' : 33
                      "
                    ></span>
                    <span class="taxes">{{ "Tax Included" | translate }}</span>
                  </span>
                </p>
              </div>

              <div *ngIf="getLeastPrice() === -1">
                <p class="organiser-name price">
                  {{ "No available tickets" | translate }}
                </p>
              </div>
            </div>
            <div *ngIf="!mobileDevice" class="text-center">
              <button
                (click)="openRegisterModal()"
                [disabled]="checkBookAvailability() !== 'available'"
                class="btn btn-primary book-btn"
              >
                <span *ngIf="checkBookAvailability() === 'available'">
                  {{ "Book your ticket" | translate }}
                </span>
                <span *ngIf="checkBookAvailability() === 'ended'">
                  {{ "sale-pending" | translate }}
                </span>
                <span *ngIf="checkBookAvailability() === 'CommingSoon'">
                  {{ "CommingSoon" | translate }}
                </span>
                <span *ngIf="checkBookAvailability() === 'SoldOut'">
                  {{ "SoldOut" | translate }}
                </span>
                <span *ngIf="checkBookAvailability() === 'no-tickets'">
                  {{ "No available tickets" | translate }}
                </span>
              </button>
            </div>
          </div>
          <div class="bk-white mt-4">
            <div>
              <div>
                <p class="location">{{ "event site" | translate }}</p>

                <div class="address-dec">
                  {{ event?.addressAr }}
                </div>
                <a [href]="eventLocationLink" target="_blank">
                  <img
                    src="assets/images/details/map.svg"
                    style="cursor: pointer; width: 100%"
                  />
                </a>
              </div>
            </div>
          </div>
          <div
            *ngIf="event.policies?.length > 0 && mobileDevice"
            class="bk-white mt-4"
          >
            <div>
              <div
                (click)="openPloliciesMobile = !openPloliciesMobile"
                class="d-flex justify-content-between align-items-center"
              >
                <h4 class="event-title">
                  {{ "Terms and Conditions" | translate }}
                </h4>
                <i *ngIf="!openPloliciesMobile" class="fa fa-chevron-down"></i>
                <i *ngIf="openPloliciesMobile" class="fa fa-chevron-up"></i>
              </div>
              <div *ngIf="openPloliciesMobile">
                <div
                  *ngFor="let policy of event.policies"
                  [innerHTML]="policy.nameAr | safeHTML"
                ></div>
              </div>
            </div>
          </div>
          <div>
            <div class="sponsor-container">
              <a
                class="sponsor"
                *ngFor="let sponsor of event.eventSponsors"
                [href]="sponsor?.sponsorURL"
                target="_blank"
              >
                <img
                  [src]="sponsor?.image?.url"
                  class="sponsor-logo"
                  [alt]="sponsor?.name"
                />
              </a>
            </div>
          </div>
          <div *ngIf="mobileDevice" class="text-center book-btn-div">
            <button
              (click)="openRegisterModal()"
              [disabled]="checkBookAvailability() !== 'available'"
              class="btn btn-primary book-btn"
            >
              <span *ngIf="checkBookAvailability() === 'available'">
                {{ "Book your ticket" | translate }}
              </span>
              <span *ngIf="checkBookAvailability() === 'ended'">
                {{ "sale-pending" | translate }}
              </span>
              <span *ngIf="checkBookAvailability() === 'CommingSoon'">
                {{ "CommingSoon" | translate }}
              </span>
              <span *ngIf="checkBookAvailability() === 'SoldOut'">
                {{ "SoldOut" | translate }}
              </span>
              <span *ngIf="checkBookAvailability() === 'no-tickets'">
                {{ "No available tickets" | translate }}
              </span>
            </button>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</section>
<app-footer></app-footer>
